define('app/views/carousel',['require','./baseview','hammerjs'],function(require){

  var BaseView = require('./baseview');
  var Hammer = require('hammerjs');

  var Carousel = BaseView.extend({

    view: 'carousel',
    slides: [],
    activeSlides: [],
    index: 0,
    direction: 1,
    intervalID: 0,

    defaults: {
      autoPlay: true, //whether slideshow advances automatically
      circular: true, //instead of stopping, last slide loops to first slide
      interval: 7000, //time between autoplay in milliseconds
      animation: 'fade', //'fade' or 'wipe'
      easing: Power2.easeOut, //easing for the animation
      duration: 0.5, //animation time in seconds
      shuffle: false,
      touch: true,
      slideTemplate: ''
    },

    initialize: function(options){
      BaseView.prototype.initialize.call(this, options);

      _.bindAll(this,
        'previous',
        'next',
        '_onImageLoaded'
      );

      if(this.options.prev){
        $('body').on('click.' + this.cid, this.options.prev, this.previous);
      }

      if(this.options.next){
        $('body').on('click.' + this.cid, this.options.next, this.next);
      }

      if(this.options.touch){
        var hammer = new Hammer(this.$el.get(0), { dragBlockHorizontal: true, swipeVelocityX: 0.2 });
        hammer.on('swipeleft', this.next);
        hammer.on('swiperight', this.previous);
      }

      this.setSlides($('.slide', this.$el));
      this.getSlides().detach().eq(0).addClass('active').appendTo(this.$el);
      this._autoplay();
    },

    option: function(key, val){
      if(typeof val === 'undefined'){
        return this.options[key];
      } else {
        return this.options[key] = val;
      }
    },

    getSlide: function(index){
      return this.slides.eq(index);
    },

    getSlides: function(){
      return this.slides;
    },

    setSlides: function(slides){
      if(this.options.shuffle) {
        this.slides = slides.shuffle().appendTo(this.$el);
      } else {
        this.slides = slides;
      }
    },

    getIndex: function(){
      return this.index;
    },

    setIndex: function(index){
      var lower = 0;
      var upper = Math.max(this.slides.length - 1, 0);
      if(this.options.circular){
        if(index < lower) index = upper;
        if(index > upper) index = lower;
      } else {
        if(index <= lower){
          console.log('slide index out of bounds: ' + index);
          index = lower;
          this.trigger(Carousel.BEGIN);
        } else if(index > upper){
          console.log('slide index out of bounds: ' + index);
          index = upper;
          this.trigger(Carousel.END);
        }
      }
      this.index = index;
      return this.index;
    },

    previous: function(e){
      this.direction = 1;
      this.goto(this.index - 1);
    },

    next: function(e){
      this.direction = -1;
      this.goto(this.index + 1);
    },

    goto: function(index){
      if(this._checkLoading()){
        console.log('slides currently loading');
      } else if(this._checkAnimating()){
        console.log('slides currently animating');
      } else {
        var curIndex = this.getIndex();
        var newIndex = this.setIndex(index);
        if(curIndex == newIndex){
          console.log('already on index: ' + index);
        } else {
          //store cur/new slide as active slides
          var curSlide = this.getSlide(curIndex);
          var newSlide = this.getSlide(newIndex);
          this.activeSlides = [curSlide, newSlide];

          //preload the new slide
          var instance = newSlide.find('.image').data().instance;
          if (instance) {
            this.trigger(BaseView.BEFORE_LOADED);
            instance.on(BaseView.AFTER_LOADED, this._onImageLoaded).preload(true);
          }
        }
      }
    },

    _onImageLoaded: function(view){
      this.trigger(BaseView.AFTER_LOADED);
      view.off(BaseView.AFTER_LOADED);
      var animation = this.animation[this.options.animation];
      if(animation){
        animation.call(this);
      } else {
        console.log('could not find animation: ' + this.options.animation);
      }
    },

    _checkLoading: function(){
      var loading = false;
      _.each(this.activeSlides, function(slide){
        var instance = slide.find('.image').data().instance;
        if(instance && !instance.loaded){
          loading = true;
        }
      });
      return loading;
    },

    _checkAnimating: function(){
      return TweenMax.isTweening($('.slide', this.$el));
    },

    _doneAnimating: function(){
      this.getSlides().not('.active').detach();
      this._autoplay();
    },

    _autoplay: function(){
      clearTimeout(this.intervalID);

      if(this.options.autoPlay){
        var _self = this;
        this.intervalID = setTimeout(function(){
          _self.next();
        }, this.options.interval);
      }
    },

    animation: {

      fade: function(){
        var curSlide = this.activeSlides[0];
        if(curSlide){
          var tween = TweenMax.fromTo(curSlide, this.options.duration, { alpha: 1 }, { alpha: 0, ease: this.options.easing });
          curSlide.data('tween', tween).removeClass('active');
        }
        var newSlide = this.activeSlides[1];
        if(newSlide) {
          var tween = TweenMax.fromTo(newSlide, this.options.duration, { alpha: 0 }, { alpha: 1, ease: this.options.easing, onCompleteScope: this, onComplete: this._doneAnimating });
          newSlide.data('tween', tween).appendTo(this.$el).addClass('active');
        }
      },

      wipe: function(){
        var curSlide = this.activeSlides[0];
        if(curSlide){
          var x = 100 * this.direction;
          var tween = TweenMax.fromTo(curSlide, this.options.duration, { x: 0 }, { x: x + '%', ease: this.options.easing });
          curSlide.data('tween', tween).appendTo(this.$el).removeClass('active');
        }
        var newSlide = this.activeSlides[1];
        if(newSlide) {
          var x = -100 * this.direction;
          var tween = TweenMax.fromTo(newSlide, this.options.duration, { x: x + '%' }, { x: '0%', ease: this.options.easing, onCompleteScope: this, onComplete: this._doneAnimating });
          newSlide.data('tween', tween).appendTo(this.$el).addClass('active');
        }
      }

    }

  });

  Carousel.BEGIN = 'carouselBegin';
  Carousel.END = 'carouselEnd';

  return Carousel;

});
